import React from "react";
import { DotLoading } from 'antd-mobile'
import './index.scss'
import uuid from 'uuidjs'
// declare global {
//   interface Window {
//     mui: any;
//   }
// }
type ScrollProps = {
  load?:boolean // 是否开启加载更多
  accomplish?: boolean // 是否加载完毕
  threshold?: number // 触底大小
  loadMore?: any // 回调函数
  children?: any
  bottom?: any
  loaderror?: boolean // 加载失败
}
type ScrollState = {
  loading: boolean // 加载中
}
export default class customScroll extends React.Component<ScrollProps, ScrollState>{
  myRef: any
  uid = uuid.generate()
  constructor(props: ScrollProps) {
    super(props);
    this.myRef = React.createRef();
    this.state = {
      loading: false
    }
  }
  componentDidMount() {
    // this.setScroll()
  }

  setScroll() {
    // if (window.mui(`#${this.uid}`)?.length) {
    //   window.mui(`#${this.uid}`).scroll({
    //     deceleration: 0.0006, //flick 减速系数，系数越大，滚动速度越慢，滚动距离越小，默认值0.0006
    //     scrollY: true, //是否竖向滚动
    //     scrollX: false, //是否横向滚动
    //     startX: 0, //初始化时滚动至x
    //     startY: 0, //初始化时滚动至y
    //     indicators: false, //是否显示滚动条
    //     bounce: false //是否启用回弹
    //   });
    //   // this._touchmove()
    //   window.addEventListener('resize', ()=> {
    //     window.mui(`#${this.uid}`)?.scroll()?.refresh()
    //   })
    // } else {
    //   this.setScroll()
    // }
  }

 _touchmove() {
    const {load, accomplish, threshold = 250, loadMore} = this.props
    const { loading } = this.state
    if (accomplish)return
    if (!load) return
    if (!this.myRef.current) return
    if (loading) return
    // 获取当前盒子的高度
    const boxH = this.myRef.current.clientHeight as number
    // 获取当前滚动Y的距离
    const y = document.getElementById(this.uid)?.scrollTop as number
    // 获取父盒子高度
    const bh = document.getElementById(this.uid)?.clientHeight || 0
    // 判断如果当前盒子的高度小于等于滚动高度加父盒子高度加阈值则进行请求
    if (boxH - threshold <=  y + bh) {
      if (loadMore) {
        this.setState({
          loading: true
        })
        Promise.all([loadMore()]).then(()=>{
          this.setState({
            loading: false
          })
        }).catch(()=>{
          this.setState({
            loading: false
          })
        })
      }
    }
  }
  render() {
    const { loading } = this.state
    const { accomplish, loaderror, load } = this.props
    return <><div className="max-box">
      <div className="mui-scroll-wrapper" id={this.uid} onScroll={()=>{this._touchmove()}}>
        <div className="mui-scroll" ref={this.myRef}>
          {this.props.children}
          {load&&<div className="loading-bottom" onClick={()=>{
            if(loaderror){
              this._touchmove()
            }
          }}>
            {loading&&<div><span>加载中</span><DotLoading color='currentColor' /></div>}
            {accomplish&&<div className="no-more">没有更多了</div>}
            {loaderror&&<div className="load-err">加载错误，请点击重试</div>}
          </div>}
        </div>
      </div>
    </div>
    </>
  }
}